import { Trans, useTranslation } from 'next-i18next'
import { includes, reject } from 'ramda'

import {
  Heading2,
  LinkGrid,
  LinkText,
  Section2
} from '@/features/Listings/seo/elements'
import { Label } from '@/components/text'

interface PopularHoodsProps {
  state: string
  locationName: string
  neighbourhoodSlug: string
}

type LinkArray = string[][]

const PopularHoods = ({
  state,
  locationName,
  neighbourhoodSlug
}: PopularHoodsProps) => {
  const { t } = useTranslation()

  const HOOD_LINKS_AB: LinkArray = [
    ['calgary', 'southeast-calgary'],
    ['calgary', 'southwest-calgary'],
    ['calgary', 'northeast-calgary'],
    ['calgary', 'northwest-calgary'],
    ['edmonton', 'southeast-edmonton'],
    ['edmonton', 'southwest-edmonton'],
    ['edmonton', 'northwest-edmonton'],
    ['edmonton', 'northeast-edmonton'],
    ['edmonton', 'west-edmonton'],
    ['calgary', 'downtown'],
    ['calgary', 'inglewood'],
    ['calgary', 'bowness'],
    ['calgary', 'crescent-heights'],
    ['calgary', 'altadore'],
    ['calgary', 'brentwood'],
    ['edmonton', 'downtown']
  ]

  const HOOD_LINKS_BC: LinkArray = [
    ['vancouver', 'west-end'],
    ['vancouver', 'downtown'],
    ['vancouver', 'strathcona'],
    ['vancouver', 'grandview-woodland'],
    ['vancouver', 'hastings-sunrise'],
    ['vancouver', 'west-point-grey'],
    ['vancouver', 'kitsilano'],
    ['vancouver', 'fairview'],
    ['vancouver', 'mount-pleasant'],
    ['vancouver', 'dunbar-southlands'],
    ['vancouver', 'arbutus-ridge'],
    ['vancouver', 'shaughnessy'],
    ['vancouver', 'south-cambie'],
    ['vancouver', 'riley-park'],
    ['vancouver', 'kensington-cedar-cottage'],
    ['vancouver', 'renfrew-collingwood'],
    ['vancouver', 'kerrisdale'],
    ['vancouver', 'marpole'],
    ['vancouver', 'oakridge'],
    ['vancouver', 'sunset'],
    ['vancouver', 'victoria-fraserview'],
    ['vancouver', 'killarney'],
    ['vancouver', 'yaletown'],
    ['vancouver', 'coal-harbour'],
    ['vancouver', 'gastown'],
    ['vancouver', 'chinatown'],
    ['vancouver', 'downtown-eastside'],
    ['vancouver', 'false-creek'],
    ['richmond', 'steveston'],
    ['surrey', 'south-surrey'],
    ['burnaby', 'metrotown']
  ]

  const HOOD_LINKS_MB: LinkArray = []

  const HOOD_LINKS_NS: LinkArray = []

  const HOOD_LINKS_ON: LinkArray = []

  const HOOD_LINKS_QC: LinkArray = []

  const STATE_LINKS: Record<string, LinkArray> = {
    AB: HOOD_LINKS_AB,
    BC: HOOD_LINKS_BC,
    MB: HOOD_LINKS_MB,
    NS: HOOD_LINKS_NS,
    ON: HOOD_LINKS_ON,
    QC: HOOD_LINKS_QC
  }

  const ALL_LINKS: LinkArray = [
    ...HOOD_LINKS_AB,
    ...HOOD_LINKS_BC,
    ...HOOD_LINKS_MB,
    ...HOOD_LINKS_NS,
    ...HOOD_LINKS_ON,
    ...HOOD_LINKS_QC
  ]

  const HOOD_LINKS = STATE_LINKS[state] || ALL_LINKS
  const linksWithoutCurrent = reject(includes(neighbourhoodSlug), HOOD_LINKS)
  const hasNoLinks = linksWithoutCurrent.length === 0

  if (hasNoLinks) return null

  return (
    <Section2>
      <Heading2>
        <Trans
          i18nKey="seo:Popular Neighbourhoods Near LOCATION"
          values={{
            location: locationName
          }}
          defaults="Popular Neighbourhoods Near {{ location }}"
        />
      </Heading2>
      <LinkGrid linksOnly>
        {linksWithoutCurrent.map(hood => {
          const citySlug = hood[0]
          const hoodSlug = hood[1]
          const hoodName = t(`seo:neighbourhood_name_${hoodSlug}_${citySlug}`)
          return (
            <Label key={`${hoodSlug}-${citySlug}`} fontSize="14px">
              <LinkText href={`/rental-listings/city/${citySlug}/${hoodSlug}`}>
                <Trans
                  i18nKey="seo:city apartments for rent"
                  values={{ cityName: hoodName }}
                  defaults="{{ cityName }} apartments for rent"
                />
              </LinkText>
            </Label>
          )
        })}
      </LinkGrid>
    </Section2>
  )
}

export default PopularHoods
